import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import React from 'react'
import { useTranslation } from 'react-i18next';

function ToggleEditWarning(props) {
    const { t, i18n } = useTranslation()
    return (
        <>
            <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                <MDBIcon
                    fas
                    icon="exclamation-triangle"
                    className="me-3 fs-5 mt-1"
                    color="warning"
                />
                <div> {props.toggleValue !== undefined && props.toggleValue !== null ? props.toggleValue ? "By enabling this option" : "By disabling this option" : "The selected option"}  will affect the <span className='fw-bold'> {`${props.columnName}`}</span> setting for all the {props.isLuna ? "entities" : "users"} listed below. Are you sure you want to continue?</div>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => {
                    props.handleCloseWarning();

                }}>{t("cancel")}</MDBBtn>
                <MDBBtn onClick={(e) => props.handleUpdateToggle()}>{t("ok")}</MDBBtn>
            </MDBModalFooter>
        </>
    )
}

export default ToggleEditWarning
